
import Vue from "vue";
import { storage } from "@/plugins/firebase";
import { IBanner } from "@/types/banner";
import { mapGetters } from "vuex";
import { getDownloadURL, ref } from "firebase/storage";
import {
  getActiveBannersForCast,
  getActiveBannersForGuest,
} from "@/adapter/DbAdapter/bannerAdapter";
interface bannerInfo {
  imgUrl: string;
  href: string;
}
export default Vue.extend({
  data(): {
    isShow: boolean;
    model: number;
    bannerInfoList: bannerInfo[];
  } {
    return {
      isShow: true,
      model: 0,
      bannerInfoList: [],
    };
  },
  computed: {
    ...mapGetters({
      isCast: "auth/isCast",
    }),
  },
  created() {
    if (this.isCast) {
      getActiveBannersForCast().then(async (res) => {
        if (!res) {
          this.isShow = false;
          return;
        }
        for (const banner of res) {
          if (!banner.imgSrc) {
            continue;
          }
          await this.addImg(banner);
        }
      });
      return;
    }
    getActiveBannersForGuest().then(async (res) => {
      if (!res) {
        this.isShow = false;
        return;
      }
      for (const banner of res) {
        if (!banner.imgSrc) {
          continue;
        }
        await this.addImg(banner);
      }
    });
  },
  methods: {
    async addImg(banner: IBanner) {
      const url = await getDownloadURL(ref(storage, banner.imgSrc))
        .then(function (url) {
          return url;
        })
        .catch(function (error) {
          console.log(error);
          return "";
        });
      if (url == "") {
        return;
      }
      const data: bannerInfo = {
        imgUrl: url,
        href: banner.href,
      };
      this.bannerInfoList.push(data);
    },
  },
});
